import { AnalyticsProvider } from './analytics';
import QueryProvider from './query';
import { QuestProvider } from './quest';
import TRPCProvider from './trpc';
import { PuzzleWalletProvider } from '@puzzlehq/sdk';

const RootProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <PuzzleWalletProvider>
      <TRPCProvider>
        <QueryProvider>
          <QuestProvider>
            <AnalyticsProvider
              writeKey={import.meta.env.VITE_SEGMENT_WRITE_KEY!}
            >
              {children}
            </AnalyticsProvider>
          </QuestProvider>
        </QueryProvider>
      </TRPCProvider>
    </PuzzleWalletProvider>
  );
};

export default RootProvider;
